import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import Swiper from 'react-id-swiper';

// images
import pricelistbgshape1 from '../../images/prc-bg-shape1.png';
import pricelistbgshape2 from '../../images/prc-bg-shape2.png';
import pricelistbgshape3 from '../../images/prc-bg-shape3.png';
import next from '../../images/icon/next.png';
import prev from '../../images/icon/prev.png';
import bgShapeNew1 from '../../images/bg-shape-n1.png';

import './style.scss';

const pricelistsmonthly = [
    {
        id: 1,
        price: 'Monthly',
        type: '$10/Month',
        color: [
            {
                code: '#d858f6'
            },
            {
                code: '#f754f2'
            },
        ],
        features: [
            {
                id: 1,
                text: 'Unlimited pay stubs for every active employee'
            },
            {
                id: 2,
                text: 'Saved employee information for added ease'
            },
            {
                id: 3,
                text: 'A complete history of pay statements'
            },
            {
                id: 4,
                text: 'Option to add additional employees for $3/month'
            },
            {
                id: 5,
                text: 'Option to add extra pay stubs for $1'
            },
            {
                id: 6,
                text: 'Backdated pay stubs up to three months '
            },
        ]
    },
    {
        id: 2,
        price: 'Annual',
        type: '$100/Year',
        color: [
            {
                code: '#88cbf7'
            },
            {
                code: '#a3b6fa'
            },
        ],
        features: [
            {
                id: 1,
                text: 'Two months free!'
            },
            {
                id: 2,
                text: 'Unlimited pay stubs for every active employee'
            },
            {
                id: 3,
                text: 'Saved employee information for added ease'
            },
            {
                id: 4,
                text: 'A complete history of pay statements for all your employees'
            },
            {
                id: 5,
                text: 'Option to add additional employees for $30/year'
            },
            {
                id: 6,
                text: 'Option to add extra pay stubs for $1'
            },
            {
                id: 7,
                text: 'Backdated pay stubs up to three years '
            },
        ]
    },
    {
        id: 3,
        price: 'Pay as you Go',
        type: '$5 payStub',
        color: [
            {
                code: '#ea4e46'
            },
            {
                code: '#ff766f'
            },
        ],
        features: [
            {
                id: 1,
                text: 'Packs of 1-5 for only $5 per pay stub'
            },
            {
                id: 2,
                text: 'Packs of 5-10 for only $4 per pay stub'
            },
            {
                id: 3,
                text: 'Packs of 11 or more for only $3 per pay stub'
            },
            {
                id: 4,
                text: 'Helpdesk support '
            },
            {
                id: 5,
                text: 'Unlimited flexibility '
            },
            {
                id: 6,
                text: 'No expiration date'
            },
        ]
    },
];


const PricingPlan = () => {
    const [planpricelists] = useState(pricelistsmonthly);

    

    const params = {
    
        breakpoints: {
            1251: {
                effect: 'normal',
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 10,
                
            },
            992: {
                effect: 'normal',
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 10,
            },
            767: {
                effect: 'normal',
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 10,
            },
            240: {
                effect: 'normal',
                slidesPerView: 1.5,
                centeredSlides: false,
                spaceBetween: 0,
            }
        },

        navigation: {
            nextEl: '.sbnext',
            prevEl: '.sbprev'
        },
        renderPrevButton: () => <Grid className="sbArrow sbprev"><img  src={prev} alt="prev"/></Grid>,
        renderNextButton: () => <Grid className="sbArrow sbnext"> <img src={next} alt="next"/> </Grid>,
    };

    return(
        <Grid className="pricingPlan">
            <Grid className="container" container alignItems="center" spacing={4}>
                <Grid item xs={12} >
                    <Grid className="textContent">
                        <strong>Let’s Talk Money</strong>
                        <h4>The Process Is Simple and The Price Is Right</h4>
                        <p>No contracts, setup fees, or cancellation charges. Check out your options below and pick the one that works for you.</p>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid className="planpricelists">
                        <Swiper {...params}>
                            {planpricelists.map(item => {
                                return(
                                    <Grid key={item.id} className="swiper-slide">
                                        <Grid className="signlePrice" style={{borderTopColor: `${item.id === 1 ? '#3492FF' : item.id === 2 ? '#FFC134' : '#FF5A8D'}`}}>
                                            <h2><img src={item.id === 1 ? pricelistbgshape1 : item.id === 2 ? pricelistbgshape2 : pricelistbgshape3} alt="pricelistbgshape1"/> <span>{item.type}</span></h2>
                                            <Grid className="price">{item.price}</Grid>
                                            <ul>
                                                {item.features.map(feature => {
                                                    return <li key={feature.id}>{feature.text}</li>;
                                                })}
                                            </ul>
                                            <Button component="a" className="cBtn">Choose Plan</Button>
                                        </Grid>
                                    </Grid>
                                )
                            })}
                        </Swiper>
                    </Grid>
                </Grid>
            </Grid>
            <img className="bgShapeNew1" src={bgShapeNew1} alt="bgShapeNew1"/>
        </Grid>
    )
};

export default PricingPlan;